export default {"src":"/_next/static/media/icon_bank_withdrawal_success.57e1acc7.svg","height":39,"width":40,"blurWidth":0,"blurHeight":0};